import { makeStyles } from '@material-ui/core/styles'
import { cardHeaderStyles } from 'lib/styles/card-header'
import { PGA_COACH_ERROR_TEXT } from '../dashboard-colors'

const useStyles = makeStyles(theme => ({
  card: {
    border: '1px solid #E0E0E0',
    borderRadius: 12,
    backgroundColor: '#FFFFFF',
    overflow: 'hidden',
    minWidth: 0,
    marginBottom: theme.spacing(3),
  },
  ...cardHeaderStyles(theme),
  cardHeader: {
    ...cardHeaderStyles(theme).cardHeader,
    borderBottom: 'none',
    paddingBottom: theme.spacing(1.5),
  },
  monthButton: {
    color: theme.palette.text.secondary,
    fontWeight: 500,
    whiteSpace: 'nowrap',
  },
  grid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(4, minmax(0, 1fr))',
    gap: theme.spacing(1.5),
    padding: theme.spacing(0, 3, 3),
    [theme.breakpoints.down('sm')]: {
      gridTemplateColumns: 'repeat(2, minmax(0, 1fr))',
    },
    [theme.breakpoints.down('xs')]: {
      gridTemplateColumns: 'minmax(0, 1fr)',
      padding: theme.spacing(0, 2, 2),
    },
  },
  tile: {
    display: 'flex',
    minWidth: 0,
    '& > *': {
      flex: '1 1 auto',
      minWidth: 0,
    },
  },
  delta: {
    display: 'flex',
    alignItems: 'center',
    gap: 2,
    fontSize: '12px',
    fontWeight: 500,
    lineHeight: '18px',
    '& .MuiSvgIcon-root': {
      fontSize: 16,
    },
  },
  deltaUp: {
    color: theme.palette.success.dark,
  },
  deltaDown: {
    color: PGA_COACH_ERROR_TEXT,
  },
  deltaFlat: {
    color: theme.palette.text.secondary,
  },
}))

export default useStyles
